import { LabelMetaItem, MetaItemSection } from "o4a-react";
import * as React from "react";
import { Stack } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { metaItemLabelsGap } from "../../constants/uiConstants";
import { VmdbDatabase } from "../../gen/clients/mchub-azure-api-client-vmdb";

export enum MetaItemTestIds {
  DatabaseName = "mi-database-name",
  CharacterSet = "mi-character-set",
  NationalCharacterSet = "mi-national-character-set"
}

export interface VmDbConfigurationDetailsProps {
    cdb: VmdbDatabase | undefined;

  }
export const VmDbConfigurationDetails = (
  { cdb }: VmDbConfigurationDetailsProps,
): JSX.Element => (
  <MetaItemSection labelWidth={150}>
    <Stack tokens={{ childrenGap: metaItemLabelsGap }}>
      <LabelMetaItem testId={MetaItemTestIds.DatabaseName} label={Messages.labels.databaseName()}>
        {cdb?.dbName || ""}
      </LabelMetaItem>
      <LabelMetaItem testId={MetaItemTestIds.CharacterSet} label={Messages.labels.characterSet()}>
        {cdb?.characterSet || ""}
      </LabelMetaItem>
      <LabelMetaItem testId={MetaItemTestIds.NationalCharacterSet} label={Messages.labels.nationalCharacterSet()}>
        {cdb?.ncharacterSet || ""}
      </LabelMetaItem>
    </Stack>
  </MetaItemSection>
);
